(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('free-shipping-progress')) {
    class FreeShippingProgress extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';
        this.onCart = (event) => this.paint(event.detail?.total_price, true);
        document.addEventListener('theme:cart', this.onCart);
        this.paint(this.dataset.total, false);
      }

      disconnectedCallback() {
        if (this.onCart) document.removeEventListener('theme:cart', this.onCart);
        this.dataset.bound = 'false';
      }

      paint(total, bump) {
        const threshold = Number(this.dataset.threshold) || 0;
        const cartTotal = Number(total) || 0;
        if (!threshold) return;
        const remaining = Math.max(0, threshold - cartTotal);
        const progress = remaining === 0 ? 100 : Math.min(100, Math.max(0, (cartTotal / threshold) * 100));
        const fill = this.querySelector('[data-shipping-progress-fill]');
        const truck = this.querySelector('[data-shipping-progress-truck]');
        const track = this.querySelector('[data-shipping-progress-track]');
        const remainingEl = this.querySelector('[data-shipping-progress-remaining]');
        const away = this.querySelector('[data-shipping-progress-away]');
        const unlocked = this.querySelector('[data-shipping-progress-unlocked]');
        if (fill) fill.style.width = `${progress}%`;
        if (truck) truck.style.left = `${progress}%`;
        if (track) track.setAttribute('aria-valuenow', String(Math.round(progress)));
        if (remainingEl) remainingEl.textContent = this.formatMoney(remaining);
        if (away) away.hidden = remaining === 0;
        if (unlocked) unlocked.hidden = remaining !== 0;
        this.classList.toggle('is-unlocked', remaining === 0);
        if (bump) {
          this.classList.remove('is-bumped');
          void this.offsetWidth;
          this.classList.add('is-bumped');
        }
      }

      formatMoney(cents) {
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD' }).format(cents / 100);
      }
    }

    customElements.define('free-shipping-progress', FreeShippingProgress);
  }
  } catch(e) { console.error(e); }
})();

})();
